const MONTH_NAMES = [
  'januari', 'februari', 'mars', 'april', 'maj', 'juni',
  'juli', 'augusti', 'september', 'oktober', 'november', 'december',
];

const MONTH_SHORT = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

export const monthName = (month: number): string => MONTH_NAMES[month - 1] ?? '';
export const monthShort = (month: number): string => MONTH_SHORT[month - 1] ?? '';

/** "2026-06" -> "jun 26". Kort nog för en axeletikett. */
export function formatMonthKey(monthKey: string): string {
  const [year, month] = monthKey.split('-');
  return `${monthShort(Number(month))} ${year.slice(2)}`;
}

export function formatMonthKeyLong(monthKey: string): string {
  const [year, month] = monthKey.split('-');
  return `${monthName(Number(month))} ${year}`;
}

export const formatNumber = (value: number): string => new Intl.NumberFormat('sv-SE').format(value);

export function formatDate(iso: string | undefined): string {
  if (!iso) return '–';
  return iso.slice(0, 10);
}

export function formatDateTime(iso: string | undefined): string {
  if (!iso) return '–';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '–';
  return new Intl.DateTimeFormat('sv-SE', { dateStyle: 'short', timeStyle: 'short' }).format(date);
}

export function relativeTime(iso: string | undefined): string {
  if (!iso) return 'okänt';
  const diffMs = Date.now() - new Date(iso).getTime();
  const hours = Math.round(diffMs / 3_600_000);
  if (hours < 1) return 'nyss';
  if (hours < 24) return `för ${hours} h sedan`;
  const days = Math.round(hours / 24);
  return days === 1 ? 'igår' : `för ${days} dagar sedan`;
}

export const WORK_MODE_LABELS: Record<string, string> = {
  onsite: 'På plats',
  hybrid: 'Hybrid',
  remote: 'Distans',
  unknown: 'Ej angivet',
};

export const SENIORITY_LABELS: Record<string, string> = {
  junior: 'Junior',
  mid: 'Medior',
  senior: 'Senior',
  lead: 'Lead',
};
